import { useState } from 'react';
import Select from 'react-select';

interface Props {
    onChange: (value: boolean) => void;
    value: boolean;
}

export default function OrderIsAscendingSelector({ onChange, value }: Props) {
    const [isAscending] = useState([
        { label: 'Ascendente', value: true },
        { label: 'Descendente', value: false },
    ]);

    return (
        <div className='mb-2'>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isSearchable
                name='orderIsAscending'
                options={isAscending}
                onChange={(selectedOrderIsAscending) => {
                    onChange(selectedOrderIsAscending!.value);
                }}
                value={
                    isAscending.find((ascending) => ascending.value === value) ?? {
                        label: `Ordenar por`,
                        value: true,
                    }
                }
            />
        </div>
    );
}
